import { Component } from '@angular/core';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-projects-data',
  imports: [TranslatePipe],
  templateUrl: './projects-data.html',
  styleUrl: './projects-data.scss',
})
export class ProjectsData {}
